import axios from './axiosInstances/identityAxiosInstance';

const api = {
  /** Upload document with file (multipart/form-data) */
  async upload(formData) {
    return axios.post('/myemployee/document/Upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  /** Get all documents for an employee */
  async getByEmployeeId(employeeId) {
    return axios.post(`/myemployee/document/GetByEmployeeId/${employeeId}`);
  },

  /** Get presigned download URL for a document */
  async getDownloadUrl(docId) {
    return axios.post(`/myemployee/document/Download/${docId}`);
  },

  /** Update document metadata */
  async updateById(docId, payload) {
    return axios.post(`/myemployee/document/UpdateById/${docId}`, payload);
  },

  /** Soft delete a document */
  async deleteById(docId) {
    return axios.post(`/myemployee/document/DeleteById/${docId}`);
  },
};

export default api;
